import Base from '@studiometa/js-toolkit';
import Vue from 'vue';
import Select from 'element-ui/lib/select';
import Option from 'element-ui/lib/option';
import OptionGroup from 'element-ui/lib/option-group';
import VueSelect from './Select';
import { isDev } from '../../config';
import setElementUILocale from '../../utils/setElementUILocale';

setElementUILocale();

/**
 * Import ElementUI components
 * @see https://element.eleme.io/#/en-US/component/select
 */
Vue.component(Select.name, Select);
Vue.component(Option.name, Option);
Vue.component(OptionGroup.name, OptionGroup);

/**
 * Select class for <select>
 */
export default class MetaSelect extends Base {
  /**
   * Component configuration
   */
  get config() {
    return {
      name: 'Select',
      log: isDev(),
      filterable: false,
    };
  }

  /**
   * Mounted hook
   * Create a Vue mini application that use a Select from ElementUI
   */
  async mounted() {
    this.vue = new Vue({
      el: this.$refs.vueSelectContainer,
      render: (h) =>
        h(VueSelect, {
          props: {
            // Label / Value of all the <option> in JSON format
            options: this.$options.selectOptions,
            // Select placeholder string
            label: this.$options.label,
            // The URL parameter name used to read the default value
            urlParam: this.$options.id || '',
            popperClass: this.$options.popperClass || '',
            filterable: this.$options.filterable,
          },
          on: {
            update: this.updateChange || (() => {}),
          },
        }),
    });

    if (this.afterMounted) {
      this.afterMounted();
    }
  }

  /**
   * Destroy hook
   */
  destroyed() {
    this.vue.$destroy(true);
  }
}
